import script from "./TopbarOrganism.vue?vue&type=script&setup=true&lang=ts"
export * from "./TopbarOrganism.vue?vue&type=script&setup=true&lang=ts"

import "./TopbarOrganism.css?vue&type=style&index=0&id=19b4df5c&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19b4df5c"]])

export default __exports__